import { useDetailContentReady } from "../../../hooks/use-embarcacao-detail-load-gate";
import {
  EMBARCACAO_DETAIL_EXPORT_LABEL,
  EMBARCACAO_DETAIL_EXPORT_WAITING_TITLE,
} from "./embarcacao-detail-export-button.constants";
import type { EmbarcacaoDetailExportButtonProps } from "./types-embarcacao-detail-export-button";

/** Exportar só fica disponível quando todas as seções (e as imagens) já carregaram. */
export function useEmbarcacaoDetailExportButton({
  isExporting,
  onClick,
  size,
}: EmbarcacaoDetailExportButtonProps) {
  const waiting = !useDetailContentReady();

  return {
    label: EMBARCACAO_DETAIL_EXPORT_LABEL,
    size,
    ariaBusy: waiting || isExporting || undefined,
    title: waiting ? EMBARCACAO_DETAIL_EXPORT_WAITING_TITLE : undefined,
    disabled: waiting || isExporting,
    onClick,
  };
}
